import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Constanst } from '../core/constants/constans.component';
import { HelperClassService } from '../core/services/clase-utilidades.services';
import { ApiCallService } from '../core/services/api-call.service';
import { Router } from '@angular/router';
import { CachePartidasService } from '../core/services/cache-partidas-service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private helperService: HelperClassService, private apiCallService: ApiCallService, private router: Router, private cachePartidasService: CachePartidasService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                //console.error('intercept Error:', error);
                let errorMessage = '';
                if (error.status == 401) {
                    errorMessage = Constanst.MSG_INVALID_SESSION;
                    this.apiCallService.hideSpinner();
                    let dialog = this.helperService.openDialogGeneric('25rem', true, errorMessage, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                    dialog.afterClosed().subscribe(() => {
                        this.helperService.localStorageClear();
                        this.cachePartidasService.clear();
                        this.router.navigate(['/login']);
                    });
                } else if (error.status == 403) {
                    errorMessage = Constanst.MSG_EXPIRED_SESSION;
                    this.apiCallService.hideSpinner();
                    let dialog = this.helperService.openDialogGeneric('25rem', true, errorMessage, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
                    dialog.afterClosed().subscribe(() => {
                        this.helperService.localStorageClear();
                        this.cachePartidasService.clear();
                        this.router.navigate(['/login']);
                    });
                } /* else {
                    errorMessage = Constanst.MSG_GENERIC_ERROR;
                    this.apiCallService.hideSpinner();
                    this.helperService.openDialogGeneric('25rem', true, errorMessage, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                } */
                return throwError(() => new Error(errorMessage));
            })
        );
    }
}